<template>
    <div class="cz3__text-entry">
        <div>
            <input v-model="internalValue" :placeholder="placeholder"/>
        </div>

        <div v-if="hint" class="cz3__text-entry__hint"
            :class="{
                'cz3__text-entry__hint--error': hintError
            }"
        >
            {{hint}}
        </div>
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz3__text-entry {
            width: 100%;

            input {
                width: 100%;
                height: 68px;
                padding: 0 18px;

                line-height: 68px;

                font-family: $font-main;
                font-weight: 400;
                font-size: 16px;

                color: #000;

                background: #f5f5f5;

                border: none;
                border-radius: 8px;

                &::placeholder {
                    color: #999;
                }

                &:focus {
                    outline: 2px solid #000;
                    outline-offset: 2px;
                }
            }
        }

        .cz3__text-entry__hint {
            margin-top: 8px;

            font-family: $font-main;
            font-weight: 400;
            font-size: 12px;

            color: #000;

            &.cz3__text-entry__hint--error {
                color: #b00b00;
            }
        }
    }
</style>

<script>
    export default {
        props: {
            value: String,
            placeholder: {
                type: String,
                default: '',
            },
            hint: String,
            hintError: Boolean,
        },

        data() {
            return {
                internalValue: '',
            };
        },

        watch: {
            internalValue() {
                if (this.internalValue !== this.value) {
                    this.$emit('input', this.internalValue);
                }
            },

            value() {
                if (this.value !== this.internalValue) {
                    this.internalValue = this.value;
                }
            },
        },

        mounted() {
            this.internalValue = this.value;
        },
    };
</script>
